const CHAT_BASE = (
    process.env.REACT_APP_CHAT_SERVICE_URL || 'http://localhost:5173'
).replace(/\/$/, '');

const chatFetch = (path) =>
    fetch(`${CHAT_BASE}/api${path}`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
    });

class ChatApi {
    /** 안 읽은 채팅방 수 */
    static async getUnreadChatroomCount() {
        try {
            const res = await chatFetch('/chatrooms?filter=unread');
            if (!res.ok) return 0;
            const data = await res.json();
            // 채팅 서버가 { chatrooms: [...] } 형태로 줄 경우
            return (data.chatrooms ?? data.rooms ?? []).length;
        } catch {
            return 0;
        }
    }

    /** 미조회 open 의뢰 수 (편지 아이콘) */
    static async getOpenRequestCount() {
        try {
            const res = await chatFetch('/requests/open-count');
            if (!res.ok) return 0;
            const data = await res.json();
            return data.count ?? data.open_count ?? 0;
        } catch {
            return 0;
        }
    }
}

export default ChatApi;
